import { render, staticRenderFns } from "./CompanyFileType.vue?vue&type=template&id=0f2a5425&"
import script from "./CompanyFileType.vue?vue&type=script&lang=js&"
export * from "./CompanyFileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports